import {request} from 'api';
import {CancelToken} from 'axios';
import {PeriodInterval} from 'components/calculator/config';
import {LocaleData} from 'contexts/LocaleContext';
import {PricesResponse} from 'models/calculator';

export async function getConfig({code}: LocaleData, service: string, customOsProductId?: string) {
    return request({
        method: 'GET',
        url: `/api/prices/${service}/config`,
        params: {localeCode: code, customOsProductId},
    });
}

export async function calculate(
    {code}: LocaleData,
    service: string,
    data: unknown,
    interval: number = PeriodInterval['month'],
    cancelToken?: CancelToken,
    useCache?: boolean,
) {
    return request<PricesResponse>({
        method: 'GET',
        url: `/api/prices/${service}/calculate`,
        params: {data, localeCode: code, interval, cache: useCache},
        cancelToken,
    });
}
